import React from 'react'

// PDF сертификата «Сделано в России» СС.004904 (лежит в assets/files на сервере)
export const CERT_URL = '/assets/files/sertifikat-sootvetstviya-ss004904.pdf'
export const CERT_TITLE = 'Сертификат «Сделано в России» СС.004904'

const IMG = {
  horizontal: {
    ru: '/assets/images/made-in-russia/sdelano-v-rossii-horizontal.png',
    en: '/assets/images/made-in-russia/made-in-russia-horizontal.png',
  },
  vertical: {
    ru: '/assets/images/made-in-russia/sdelano-v-rossii-vertical.png',
    en: '/assets/images/made-in-russia/made-in-russia-vertical.png',
  },
}

/**
 * Знак «Сделано в России» — клик открывает PDF сертификата в новой вкладке.
 *
 * variant  — 'horizontal' | 'vertical'
 * pad      — белая подложка со скруглением (нужна только на тёмном фоне)
 * className — классы для ссылки (там же задаётся ширина)
 * imgClassName — классы для картинки (по умолчанию w-full — картинка по ширине ссылки)
 */
export default function MadeInRussia({
  variant = 'horizontal',
  pad = false,
  className = '',
  imgClassName = 'w-full',
}) {
  const files = IMG[variant] || IMG.horizontal

  return (
    <a
      href={CERT_URL}
      target='_blank'
      rel='noopener noreferrer'
      title={CERT_TITLE}
      className={`inline-block${pad ? ' bg-white rounded-[15px] p-[12px]' : ''} hover:opacity-90 transition-opacity duration-300 ${className}`}
    >
      <img src={files.ru} alt='Сделано в России' className={`block h-auto hide-ru ${imgClassName}`} />
      <img src={files.en} alt='Made in Russia' className={`block h-auto hide-en ${imgClassName}`} />
    </a>
  )
}
